// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I6hF","question":"styles_question___gMBX","description":"styles_description__FVT6t"};